var map = {
	"./Catsup.png": 27616,
	"./CatsupRefill.png": 80251,
	"./ChilliPepper.png": 68043,
	"./Chipotle.png": 23377,
	"./Harina.png": 73485,
	"./Jalapeno.png": 72842,
	"./Jamon.png": 52891,
	"./Notfound.png": 79898,
	"./Oil.png": 72288,
	"./Onion.png": 47432,
	"./Pasta.png": 11011,
	"./Peperoni.png": 43319,
	"./Pineapple.png": 78193,
	"./PizzaBox.png": 48770,
	"./Queso.png": 31205,
	"./Refresco.png": 65259,
	"./Salchicha.png": 99489,
	"./SalchichaItaliana.png": 91042,
	"./logo.png": 66949,
	"./logo.svg": 69574,
	"./wrocco logo.jpg": 54236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;